/**
 * <公共组件> 底部版权信息
 */
import { NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { LW_ArchiveInfo, PublicisArchiveInfo, PublicisDomain } from '@constants/global';
import { StatesService } from '@core/store/states.service';

@Component({
  selector: 'app-main-footer',
  templateUrl: './main-footer.component.html',
  styleUrls: ['./main-footer.component.less'],
  standalone: true,
  imports: [NgStyle],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MainFooterComponent {
  constructor(private statesService: StatesService) {
    if (location.hostname === PublicisDomain) {
      this.archiveInfo = PublicisArchiveInfo;
    } else {
      this.archiveInfo = this.saasUserInfo.beian_info
        ? JSON.parse(this.saasUserInfo.beian_info)
        : LW_ArchiveInfo;
    }
  }

  @Input() styleObj = {};
  // 备案信息
  archiveInfo: ArchiveInfo = {} as ArchiveInfo;
  // 用户信息
  saasUserInfo: any = this.statesService.saasUserInfo$.getValue();
}
